/* eslint-disable max-lines */

import moment from 'moment';
import React, { memo } from 'react';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { getAddCommentLoading } from 'selectors/envelopes';
import { useSelector } from 'store';

import { EnvelopeAction } from 'types';
import EnvelopeSidebarCommentItem from '../EnvelopeRightSidebar/EnvelopeSidebarCommentItem';

type ComponentProps = {
  setEditingId: React.Dispatch<React.SetStateAction<string>>;
  editingId: string;
  comments: EnvelopeAction[];
};

const CommentsList: React.FC<ComponentProps> = ({ comments, editingId, setEditingId }) => {
  const loading = useSelector(getAddCommentLoading);

  return (
    <div className="flex flex-col gap-1 pt-2 pb-3 overflow-y-auto custom-scrollbar litlingo-envelope-comment-box pl-3 pr-4">
      {loading && (
        <div className="relative pb-1 pl-1 pr-2 flex flex-col gap-1 rounded bg-litlingo-gray-0.5">
          <div className="flex flex-col gap-1">
            <div className="flex flex-col gap-0.5">
              <div className="h-5">
                <SkeletonTheme baseColor="#D6D6D6" highlightColor="#DCDCDC">
                  <Skeleton width="75%" height={20} style={{ borderRadius: 0 }} />
                </SkeletonTheme>
              </div>
              <div className="h-5">
                <SkeletonTheme baseColor="#EBEBEB" highlightColor="#EFEFEF">
                  <Skeleton width="85%" height={20} style={{ borderRadius: 0 }} />
                </SkeletonTheme>
              </div>
            </div>
            <div className="h-5 self-end">
              <SkeletonTheme baseColor="#EBEBEB" highlightColor="#EFEFEF">
                <Skeleton width={100} height={16} style={{ borderRadius: 0 }} />
              </SkeletonTheme>
            </div>
          </div>
        </div>
      )}
      {comments.length > 0 ? (
        comments
          .filter((comm) => comm.deleted_at === null)
          .sort((c1, c2) => (moment(c1.created_at).isBefore(moment(c2?.created_at)) ? 1 : -1))
          .map((item, index, arr) => (
            <EnvelopeSidebarCommentItem
              key={item.uuid}
              comment={item}
              index={index}
              arr={arr}
              editingId={editingId}
              setEditingId={setEditingId}
            />
          ))
      ) : (
        <span className="text text--large">There are no comments yet</span>
      )}
    </div>
  );
};

const MemoizedCommentsList = memo(CommentsList);

export default MemoizedCommentsList;
